export default {
  "Studies available": "Estudios disponibles",
  "Studies limit about":
    "La cantidad de estudios que se pueden procesar es limitada. Para aumentar el límite, contacte a su gerente o escriba a sales@3opinion.ai",
  "Studies limit reached":
    "Se ha alcanzado el límite de procesamiento de estudios. Para aumentarlo, contacte a su gerente o escriba a sales@3opinion.ai",
  "Wait for upload": "Espere a que finalice la carga actual",
  Upload: "Subir",
  directory: "Subir carpeta",
  zip: "Subir archivos",
  gender: "Sexo, edad",
  Name: "Nombre",
  Status: "Estado de procesamiento",
  studyDate: "Fecha del estudio",
  uploadDate: "Fecha de carga",
  "Dicom count": "Imágenes",
  Action: "Acción",
  Delete: "Eliminar",
  "Delete confirm": "¿Está seguro de que desea eliminar el estudio?",
  "Delete confirm about": "Al eliminar, el límite de procesamiento no cambiará",
  "No studies": "No hay estudios",
  Search: "Buscar",
  Cancel: "Cancelar",
  "Study status none": "No iniciado",
  "Study status proccess": "En proceso",
  "Study status not_found": "No se encontraron patologías",
  "Study status found": "Se encontraron patologías",
  Wait: "Esperando",
  "Zip processed": "Comprimiendo",
  Done: "Hecho",
  "Success upload":
    "Archivos subidos con éxito. Espere la actualización de la lista de estudios",
  "Upload error": "Servidor no disponible, intente más tarde",
  "Reach files size":
    "Carga no posible. Se ha superado el tamaño total permitido de archivos",
  "Upload process": "Procesando",
  Yes: "Sí",
  No: "No",
  "Study in queue": "En cola",
  "Study in proccess": "Procesando",
  "Study not found": "No se encontraron patologías",
  "Study found": "Se encontraron patologías",
  "Study error": "Error de procesamiento",
  "Study error about": "Error de carga, intente subir el estudio nuevamente",
  patientID: "ID del paciente",
  male_short: "M",
  female_short: "F",
  "Wait for anonimization": "Anonimizando",
  "Wait for loading": "Cargando",
  "Studies title": "Lista de estudios | " + process.env.VUE_APP_INSTALL_NAME,
  "Error upload":
    "El formato de los archivos cargados no cumple los requisitos",
  undefined__error:
    "El formato de los archivos cargados no cumple los requisitos",
  good: "Bien",
  step0:
    "Puede subir una carpeta con estudios, el servicio los anonimizará y procesará mediante inteligencia artificial",
  step1:
    "Sus estudios se están cargando, <br> esto puede tardar varios minutos. <br><br> La carga se realiza en segundo plano; mientras tanto, puede revisar otros estudios.",
  step2:
    "Aquí aparecerá el estudio procesado por IA. <br><br> El procesamiento puede tardar unos minutos y se realiza en segundo plano. Puede revisar otros estudios mientras espera.",
  "Demo Upload text": "Podrá procesar sus estudios después de registrarse",
  Register: "Registrarse",
  "Demo Banner Text":
    "Cree una cuenta y obtenga acceso completo a los servicios de IA y cursos educativos",
  Okay: "Entendido",
  "Mobile Notification":
    "Al acceder desde un dispositivo móvil, la funcionalidad está limitada.<br> Para el acceso completo, abra el sitio en una computadora.",
  "Studies limit Demo about":
    "Podrá procesar sus estudios en su cuenta personal después de registrarse",
  "Dicom count v2": "Cortes",
  prev: "Anterior",
  next: "Siguiente",
  "Files select": "Archivos seleccionados",
  "Access files": "Cumplen con los requisitos del servicio",
  "Access files about": "Se están cargando al servidor para análisis por IA",
  "Skip files": "No aptos",
  "Tags values": "Valores de etiquetas",
  "Skip files about": "no cumplen con los requisitos del servicio",
  Check: "Verificar",
  "Status short": "Estado",
  More: "Ampliar",
  TagError: {
    tail: "<br><br> Seleccione otro estudio o <a target='_blank' class='demo__underline demo__color--white' href='https://t.me/thirdopinion_support_bot'>escriba al soporte técnico</a>",
    not_exist: "Falta la etiqueta <TAG> del estudio",
    some_error:
      "La etiqueta <TAG> con valor <TAG_VALUE> no cumple con los requisitos del servicio <RULES>",
    PatientsAge: "Edad del paciente menor de 18 años",
    Modality: "Modalidad",
    SliceThickness: "Grosor del corte",
    BodyPartExamined: "Parte del cuerpo examinada",
    StudyInstanceUID: "StudyInstanceUID",
    SeriesInstanceUID: "SeriesInstanceUID",
  },
};
